// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d1gq","colBig":"styles_colBig__1IBtT","colSmall":"styles_colSmall__bg2zv","shopifyNameWrapper":"styles_shopifyNameWrapper__TbNYA"};